export enum Pages {
  // Login
  LOGIN = "login",
  GLOBAL_LOGIN = "global_login",
  CONTEXT_LOGIN = "context_login",
  CONTEXT_CONTACT = "context_contact",
  ANON_CONTACT = "anon_contact",
  OTP = "otp",
  AGENT_CONSENT = "agent_consent",

  // Overview
  ACCOUNTS = "accounts",

  // Onboarding
  ACCOUNT = "account",
  PLAN_SUMMARY = "plan_summary",
  LANDING_PAGE = "landing_page",
  PAYMENT_SUCCESS = "payment_success",
  T_C = "t_c",
  PAYMENT_SUMMARY = "payment_summary",
  PARTIAL_PAYMENT = "partial_payment",
  DISPUTE_NOTE = "dispute_note",
  DISPUTE_CONTACT = "dispute_contact",
  DISPUTE_REASON = "dispute_reason",
  DISPUTE_REVIEW = "dispute_review",
  DISPUTE_HOW_TO_PROCEED = "dispute_how_to_proceed",
  FRAUD_NOTE = "fraud_note",
  DISPUTE_FILE = "dispute_file",
  DISPUTE_SUCCESS = "dispute_success",
  VERIFICATION_REQUEST_CHANNEL = "verification_request_channel",
  VERIFICATION_REQUEST_CONTACT = "verification_request_contact",
  VERIFICATION_REQUEST_FINAL = "verification_request_final",
  GET_HELP = "get_help",
  MANAGE_CONTACT = "manage_contact",
  VALIDATION_NOTICE = "validation_notice",
  QUESTION_INTRO = "question_intro",
  EDUCATIONAL = "educational",
  QUESTION_LOADER = "question_loader",
  HARDSHIP_INTRO = "hardship_intro",
  HARDSHIP_LOADER = "hardship_loader",
  HARDSHIP_PLANS_VIEW = "hardship_plans_view",
  PAYMENT_FAILED_DIALOG = "payment_failed_dialog",
  ANOTHER_FAILED_PAYMENT_DIALOG = "another_failed_payment_dialog",
  BLOCKED_ACH_DIALOG = "blocked_ach_dialog",
  BLOCKED_ACH = "blocked_ach",
  EXPIRED_CAMPAIGN = "expired_campaign",
  ACH_FORM = "ach_form",

  // Consolidated payment plan
  CONSOLIDATED_PLAN = "consolidated_plan",

  PROFILE = "profile",

  // Global
  CHAT = "chat",
  CHAT_BANNER = "chat_banner",
  MENU = "menu",
  LANGUAGE_SWITCHER = "language_switcher",

  // App
  DASHBOARD = "dashboard",
  MANAGE_PAYMENT = "manage_payment",
  EARLY_PAYOFF = "early_payoff",
  ONE_TIME_PAYMENT_DIALOG = "one_time_payment_dialog",
  MANAGE_PAYMENT_METHOD = "manage_payment_method",
  MANAGE_PAYMENT_METHOD_PAGE = "manage_payment_method_page",
  CANCELLATION_INFO = "CANCELLATION_INFO",
  CANCELLATION_REASONS = "CANCELLATION_REASONS",
  SWITCH_TO_AUTOPAY = "switch_to_autopay",
  ACCOUNT_DETAILS = "account_details",
  LEAVE_REVIEW = "leave_review",
  RESCHEDULE_PLAN = "reschedule_plan",
  RETRY_PAYMENT = "retry_payment",
  RETRY_PAYMENT_FAILED = "retry_payment_failed",

  // Guest Payment Link
  EXPIRED_PAYMENT_LINK = "expired_payment_link",
  GUEST_CHECKOUT = "guest_checkout",
  GUEST_PAYMENT_CHECKOUT = "guest_payment_checkout",
  PLAN_OFFER_REVIEW = "plan_offer_review",
  PLAN_OFFER_ACCEPTED = "plan_offer_accepted",
  PLAN_OFFER_UNAVAILABLE = "plan_offer_unavailable",

  // Rewards Program
  REWARDS_PROGRAM_INTRO_ALERT = "rewards_program_intro_alert",
  REWARDS_PROGRAM_HOW_IT_WORKS_DIALOG = "rewards_program_how_it_works_dialog",

  REWARDS_PROGRAM_PLAN_OVERVIEW = "rewards_program_plan_overview",
  REWARDS_PROGRAM_REWARDS_DASHBOARD = "rewards_program_rewards_dashboard",

  REWARDS_PROGRAM_REDEEM_DIALOG = "rewards_program_redeem_dialog",
  REWARDS_PROGRAM_LOCKED_DIALOG = "rewards_program_locked_dialog",
  REWARDS_PROGRAM_UNAVAILABLE_DIALOG = "rewards_program_unavailable_dialog",
  REWARDS_PROGRAM_PENDING_DIALOG = "rewards_program_pending_dialog",

  REWARD_PROGRAM_BOOST_PAYMENT_DIALOG = "reward_program_boost_payment_dialog",

  REWARDS_PROGRAM_HISTORY = "rewards_program_history",
  REWARDS_PAYMENT_SUCCESS_DIALOG = "rewards_payment_success_dialog",
  REWARDS_PROGRAM_DISCONTINUED = "rewards_program_discontinued",
}
